// extracted by mini-css-extract-plugin
export default {"logoBar":"Layout_logoBar__3axw4","logo":"Layout_logo__5ur0J"};